<template>
  <!-- Password Authentication -->
  <div class="modal fade" id="password-security">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{$t('settings_password_security_title')}}</h5>
          <button type="button" class="close" data-bs-dismiss="modal" :aria-label="$t('close')">
            <span class="material-icons">close</span>
          </button>
        </div>
        <div class="modal-body login-security">
          <p v-if="message" class="text-success">{{message}}</p>
          <p v-else-if="error" class="text-danger">{{ error }}</p>
          <p v-else>{{$t('settings_password_security_description')}}</p>

          <!-- Card -->
          <div class="mute-chat-btn">
            <a id="btn-password-close" class="btn btn-secondary btn-block" data-bs-dismiss="modal" :aria-label="$t('close')">
              <i class="feather-x me-1"></i>{{$t('cancel')}}
            </a>
            <a class="btn btn-primary btn-block" @click.prevent="getResetPasswordLink">
              <i class="feather-check me-1"></i>{{$t('settings_password_security_get_link')}}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Password Authentication -->

  <!-- Privacy -->
  <div class="modal fade" id="privacy">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{$t('settings_privacy_title')}}</h5>
          <button type="button" class="close" data-bs-dismiss="modal" :aria-label="$t('close')">
            <span class="material-icons">close</span>
          </button>
        </div>

        <div class="modal-body">
          <div class="privacy-group">
            <div class="privacy-detail-blk">
              <div class="privacy-content">
                <h6>{{$t('settings_privacy_profile_pic_title')}}</h6>
                <p>{{$t('settings_privacy_profile_pic_description')}}</p>
              </div>
              <div>
                <vue-select v-model="form.privacy_profile_picture_visibility" :options="visibilityOptions"/>
              </div>
            </div>
            <div class="privacy-detail-blk">
              <div class="privacy-content">
                <h6>{{$t('settings_privacy_last_seen_title')}}</h6>
                <p>{{$t('settings_privacy_last_seen_description')}}</p>
              </div>
              <div>
                <vue-select v-model="form.privacy_last_seen_visibility" :options="visibilityOptions" />
              </div>
            </div>
            <div class="privacy-detail-blk">
              <div class="privacy-content">
                <h6>{{$t('settings_privacy_status_title')}}</h6>
                <p>{{$t('settings_privacy_status_description')}}</p>
              </div>
              <div>
                <vue-select v-model="form.privacy_status_visibility" :options="visibilityOptions" />
              </div>
            </div>
          </div>
          <div class="mute-chat-btn">
            <a class="btn btn-secondary btn-block" data-bs-dismiss="modal" :aria-label="$t('close')">
              <i class="feather-x me-1"></i>{{$t('Cancel')}}
            </a>
            <a class="btn btn-primary btn-block" data-bs-dismiss="modal" :aria-label="$t('close')" @click.prevent="submitForm">
              <i class="feather-check me-1"></i>{{$t('save')}}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Privacy -->

  <!-- Notifications -->
  <div class="modal fade" id="setting-notification">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{$t('settings_notifications_title')}}</h5>
          <button type="button" class="close" data-bs-dismiss="modal" :aria-label="$t('close')">
            <span class="material-icons">close</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="notification-group">
            <div class="privacy-detail-blk">
              <div class="privacy-content notify-content">
                <h6>{{$t('settings_notifications_message_title')}}</h6>
                <p>{{$t('settings_notifications_message_description')}}</p>
              </div>
              <div>
                <vue-select v-model="form.notifications_web" :options="toggleOptions" id="message_notifications" :placeholder="$t('Choose')" @select="onChangeWebNotifications"/>
              </div>
            </div>

            <div class="privacy-detail-blk">
              <div class="privacy-content notify-content">
                <h6>{{$t('settings_notifications_sounds_title')}}</h6>
                <p>{{$t('settings_notifications_sounds_description')}}</p>
              </div>
              <div>
                <vue-select v-model="form.notifications_sound" :options="toggleOptions" id="sound_notifications" :placeholder="$t('Choose')" />
              </div>
            </div>
          </div>

          <div class="mute-chat-btn">
            <a class="btn btn-secondary btn-block" data-bs-dismiss="modal" :aria-label="$t('close')">
              <i class="feather-x me-1"></i>{{$t('Cancel')}}
            </a>
            <a class="btn btn-primary btn-block" data-bs-dismiss="modal" :aria-label="$t('close')" @click.prevent="submitForm">
              <i class="feather-check me-1"></i>{{$t('Save')}}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Notifications -->

  <!-- Languages -->
  <div class="modal fade" id="setting-languages">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{$t('settings_languages_title')}}</h5>
          <button type="button" class="close" data-bs-dismiss="modal" :aria-label="$t('close')">
            <span class="material-icons">close</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="languages-group mb-4">
            <div>
              <vue-select
                v-model="form.app_language"
                :options="languageOptions"
                id="language"
                :placeholder="$t('choose')"
              />
            </div>
          </div>
          <div class="mute-chat-btn">
            <a class="btn btn-secondary btn-block" data-bs-dismiss="modal" :aria-label="$t('close')">
              <i class="feather-x me-1"></i>{{ $t('cancel') }}
            </a>
            <a class="btn btn-primary btn-block" data-bs-dismiss="modal" :aria-label="$t('close')" @click.prevent="submitForm">
              <i class="feather-check me-1"></i>{{$t('save')}}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Languages -->

  <!-- Terms & Conditions -->
  <div class="modal fade" id="terms">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{$t('settings_terms_conditions_title')}}</h5>
          <button type="button" class="close" data-bs-dismiss="modal" :aria-label="$t('close')">
            <span class="material-icons">close</span>
          </button>
        </div>
        <div class="modal-body">
          {{$t('settings_terms_conditions_description')}}
        </div>
      </div>
    </div>
  </div>
  <!-- /Terms & Conditions -->

  <!-- Privacy policy -->
  <div class="modal fade" id="privacy-policy">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{$t('settings_privacy_policy_title')}}</h5>
          <button type="button" class="close" data-bs-dismiss="modal" :aria-label="$t('close')">
            <span class="material-icons">close</span>
          </button>
        </div>
        <div class="modal-body">
          {{$t('settings_privacy_policy_description')}}
        </div>
      </div>
    </div>
  </div>
  <!-- /Privacy policy -->

  <!-- Logout -->
  <div class="modal fade" id="setting-logout">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{$t('logout')}}</h5>
          <button type="button" class="close" data-bs-dismiss="modal" :aria-label="$t('close')">
            <span class="material-icons">close</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="logout-group mb-4">
            <p>{{$t('settings_logout_description')}}</p>
          </div>
          <div class="mute-chat-btn">
            <a class="btn btn-secondary btn-block" data-bs-dismiss="modal" :aria-label="$t('close')">
              <i class="feather-x me-1"></i>{{$t('cancel')}}
            </a>
            <a class="btn btn-primary btn-block" data-bs-dismiss="modal" :aria-label="$t('close')" @click="logout">
              <i class="feather-check me-1"></i>{{$t('logout')}}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Logout -->

  <!-- Delete account -->
  <div class="modal fade" id="delete-account">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{$t('settings_delete_account_title')}}</h5>
          <button type="button" class="close" data-bs-dismiss="modal" :aria-label="$t('close')">
            <span class="material-icons">close</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="logout-group mb-4">
            <p>{{$t('settings_delete_account_description1')}}</p>
            <p>{{$t('settings_delete_account_description2')}}</p>
            <p>{{$t('settings_delete_account_description3')}}</p>
          </div>
          <div class="mute-chat-btn">
            <a class="btn btn-secondary" data-bs-dismiss="modal" :aria-label="$t('close')">
              {{$t('settings_delete_account_button')}}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Delete account -->
</template>

<script>
import { ref } from "vue";
import {mapGetters} from "vuex";
const currentDate = ref(new Date());

export default {
  data() {
    return {
      error: '',
      form: {
        //
      },
      resetPasswordForm: {
        password: '',
        password1: '',
        password2: '',
      },
      select2: null,
      startdate: currentDate,
      dateFormat: "dd-MM-yyyy",
      Everyone: ["Everyone"],
      Contacts: ['Everyone', "My contacts"],
      Only: ["Only Share With", "Friends", "Selected Friends"],
      Language: ["Choose Language", "English"],
      Gender: ["Male", "Female", "Trans-Gender"],
      Country: ["India", "USA", "China"],
      showPassword: false,
      password: null,
      showPassword1: false,
      password1: null,
      showPassword2: false,
      password2: null,
      message: '',
    };
  },

  computed: {
    ...mapGetters({
      settings: 'settings/settings',
      languages: 'settings/languages',
    }),

    visibilityOptions() {
      return [
        {
          id: 'anyone',
          text: 'Anyone',
        },
      ];
    },

    toggleOptions() {
      return [
        {
          id: 'enabled',
          text: 'Enabled',
        },
        {
          id: 'disabled',
          text: 'Disabled',
        },
      ];
    },

    languageOptions() {
      return this.languages.map(e => {
        return {
          id: e.key,
          text: e.label,
        };
      });
    },

    buttonLabel() {
      return this.showPassword ? "Hide" : "Show";
    },
    buttonLabel1() {
      return this.showPassword1 ? "Hide" : "Show";
    },
    buttonLabel2() {
      return this.showPassword2 ? "Hide" : "Show";
    },
  },

  mounted() {
    this.form = {...this.settings};
  },

  methods: {
    async logout() {
      await this.$store.dispatch('auth/logout');
      window.location.href = '/login';
    },

    async getResetPasswordLink() {
      this.error = '';
      this.message = '';
      const r = await this.$store.dispatch('auth/getResetPasswordLink');

      if (r.success) {
        this.message = 'A Reset Password Link has been sent to your email address.';
      } else {
        this.error = 'Something went wrong. Please try again in a few moments.';
      }
    },

    toggleShow() {
      this.showPassword = !this.showPassword;
    },
    toggleShow1() {
      this.showPassword1 = !this.showPassword1;
    },
    toggleShow2() {
      this.showPassword2 = !this.showPassword2;
    },

    async onChangeWebNotifications() {
      if (this.form.notifications_web === 'enabled') {
        await this.$store.dispatch('notify', {message: 'Notifications enabled.', passCheck: true});
      }
    },

    async submitForm() {
      await this.$store.dispatch('settings/store', this.form);
      await this.$store.dispatch('settings/get');
      await this.$store.dispatch('setupTranslations');
    },
  },
};
</script>
